import React from 'react';
import './StickyCta.css';
import { Link } from 'react-router-dom';

const phoneDisplay = '0533 490 44 28';
const phoneCall = '05334904428';
// WhatsApp için yeni numara: 0533 490 44 28 -> uluslararası: 905334904428
const waNumber = '905334904428';

const pushEvent = (action: string) => {
  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).dataLayer.push({
    event: 'cta_click',
    cta_action: action,
  });
};

const StickyCta: React.FC = () => {
  return (
    <div className="sticky-cta">
      <a
        className="cta-btn call"
        href={`tel:${phoneCall}`}
        onClick={() => pushEvent('call')}
      >
        Hemen Ara
      </a>
      <a
        className="cta-btn whatsapp"
        href={`https://wa.me/${waNumber}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => pushEvent('whatsapp')}
      >
        WhatsApp
      </a>
      <Link
        className="cta-btn quote"
        to="/teklif"
        onClick={() => pushEvent('quote')}
      >
        Teklif Al
      </Link>
    </div>
  );
};

export default StickyCta; 